import React, { useEffect, useState, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import "./css/bootstrap.min.css";
import "./css/style.css";
import "./css/animate.css";
import "./css/animate.min.css";
import "./css/owl.carousel.min.css";
import "./App.css";
import Loading from './common/Loading';
import WOW from "wow.js";
import ChatGPTMain from './pages/ChatGPT/Main';
// Lazy load the components
import { load } from '@cashfreepayments/cashfree-js';


const MainComponent = React.lazy(() => import('./pages/Main'));
const AboutComponent = React.lazy(() => import('./pages/About'));
const ContactComponent = React.lazy(() => import('./pages/Contact'));
const NewsComponent = React.lazy(() => import('./pages/News'));
const FeatureComponent = React.lazy(() => import('./pages/Feature'));
const PrivacyPolicy = React.lazy(() => import('./pages/privacy-policy'));
const TermsCondition = React.lazy(() => import('./pages/TermsCondition'));
const RefundPolicy = React.lazy(() => import('./pages/RefundPolicy'));
const Header = React.lazy(() => import('./components/Header'));
const FooterComponent = React.lazy(() => import('./pages/Footer'));
const JoinComponent = React.lazy(() => import('./pages/join'));
const TermsAndConditions = React.lazy(() => import('./pages/Tabs/TermsAndConditions_partner'));
const TermsAndConditionsManager = React.lazy(() => import('./pages/Tabs/TermsAndConditions_manager'));

export let cashfree;

let initializeSDK = async function () {
  cashfree = await load({
    mode: "production", // Use "test" for testing environment
  })
}

initializeSDK();

function App() {
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const hideHeaderFooterRoutes = ['/privacy-policy', '/terms-condition', '/refund-policy','/business-join-our-team-policy','/manager-join-our-team-policy'];

  const shouldHideHeaderFooter = hideHeaderFooterRoutes.includes(location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0); // if user scrolls down even a little, make it sticky
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll); // cleanup
    };
  }, []);

  useEffect(() => {
    new WOW().init();
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className="container-xxl bg-white p-0">
      <Suspense fallback={<Loading />}>
        {!shouldHideHeaderFooter && !user && <Header />}

        <Routes>
          <Route path="/" element={<MainComponent />} />
          <Route path="/feature" element={<FeatureComponent />} />
          <Route path="/news" element={<NewsComponent />} />
          <Route path="/join" element={<JoinComponent />} />
          <Route path="/about" element={<AboutComponent />} />
          <Route path="/contact" element={<ContactComponent />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/business-join-our-team-policy" element={<TermsAndConditions />} />
          <Route path="/manager-join-our-team-policy" element={<TermsAndConditionsManager />} />
          <Route path="*" element={<MainComponent />} />
          <Route path="/pension-ai" element={<ChatGPTMain />} />
        </Routes>

        {!shouldHideHeaderFooter && !user && <FooterComponent />}
        <a className="btn btn-lg btn-lg-square back-to-top pt-2" style={{ display: isSticky ? "inline" : "none" }}
          onClick={scrollToTop}
        >
          <i className="bi bi-arrow-up text-white"></i>
        </a>
      </Suspense>
    </div>
  );
}

export default App;
